import { GuestForm } from './GuestForm';

type GuestFormProps = {
  isGenderSpecific: 'M' | 'F' | boolean;
  guestIndex: number;
  isDisabled: boolean;
  withGenderSelect: boolean;
  roomNumber?: number;
};

export function GuestDetails({
  isGenderSpecific,
  guestIndex,
  isDisabled,
  withGenderSelect,
  roomNumber = 0,
  ...rest
}: GuestFormProps) {
  return (
    <form {...rest}>
      <fieldset disabled={isDisabled}>
        <GuestForm
          withLeadGuest={true}
          isGenderSpecific={isGenderSpecific}
          withGenderSelect={withGenderSelect}
          guestIndex={guestIndex}
          roomNumber={roomNumber}
        />
      </fieldset>
    </form>
  );
}
